import React, { Fragment } from 'react';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';
import numeral from 'numeral';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { showNotification } from './../../../utils';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const Table = React.memo((props) => {
    const isPersonal = props.user && [5, 6].includes(parseInt(props.user.uth_type));

    const handleChangeQuantity = (id, event) => {
        props.changeQuantity(id, event.target.value);
    };

    // const handleChangeItemQuantity = (index, event) => {
    //     props.changeItemQuantity(index, event.target.value);
    // };

    // const handleUpdateQuantity = (id, quantity) => {
    //     props.changeQuantity(id, quantity);
    // };

    const handleEditProduct = (id) => {
        props.editProduct(id, props.history);
    };

    const renderApparelDetails = (persons, mainItem) => {
        if (persons == null) {
            return null;
        }

        return persons.map((person, index1) => {
            return person.items.map((item, index2) => {
                let logoColumn = null;
                let logoImgColumn = null;
                if (person.logo !== undefined) {
                    let logoName = '';
                    if (parseInt(person.logo) === 1) {
                        logoName = 'UT Physicians';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/utp-logo-140524.png" alt="UT Physicians" /></td>;
                    } else if (parseInt(person.logo) === 2) {
                        if (person.isUthHouston !== undefined && person.isUthHouston != null && parseInt(person.isUthHouston) === 1) {
                            logoName = 'Heart and Vascular';
                            logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/uth-houston-logo-low.png" alt="UTHealth Houston" /></td>;
                        } else {
                            logoName = 'UTHealth Houston';

                            let templateCode = parseInt(mainItem.template_code);
                            if ([22, 23, 24, 25, 30, 31, 32, 33, 39, 40, 44, 45, 46, 51, 52, 53, 60, 61, 63, 64, 65, 66, 67, 69, 70, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100].includes(templateCode)) {
                                logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/uth-new-logo-low.png" alt="UTHealth Houston" /></td>;
                            } else if ([102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 126].includes(templateCode)) {
                                logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-new-logo.png" alt="UTHealth Houston" /></td>;
                            }
                        }
                    } else if (parseInt(person.logo) === 4) {   // Cizik School of Nursing
                        logoName = 'Cizik School of Nursing';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-cizik.logo.png" alt="Cizik School of Nursing" /></td>;
                    } else if (parseInt(person.logo) === 5) {   // McGovern Medical School
                        logoName = 'McGovern Medical School';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-mcgovern-logo.png" alt="McGovern Medical School" /></td>;
                    } else if (parseInt(person.logo) === 6) {   // School of Biomedical Informatics
                        logoName = 'School of Biomedical Informatics';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-biomedical-informatics-logo.png" alt="School of Biomedical Informatics" /></td>;
                    } else if (parseInt(person.logo) === 7) {   // School of Dentistry
                        logoName = 'School of Dentistry';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-dentistry-logo.png" alt="School of Dentistry" /></td>;
                    } else if (parseInt(person.logo) === 8) {   // School of Public Health
                        logoName = 'School of Public Health';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-public-health-logo.png" alt="School of Public Health" /></td>;
                    } else if (parseInt(person.logo) === 9) {   // UTHealth Houston General
                        logoName = 'UTHealth Houston General';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-general-logo.png" alt="UTHealth Houston General" /></td>;
                    } else if (parseInt(person.logo) === 10) {   // School of Public Health - Austin
                        logoName = 'School of Public Health - Austin';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-austin.png" alt="School of Public Health - Austin" /></td>;
                    } else if (parseInt(person.logo) === 11) {   // School of Public Health - Brownsville
                        logoName = 'School of Public Health - Brownsville';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-brownsville.png" alt="School of Public Health - Brownsville" /></td>;
                    } else if (parseInt(person.logo) === 12) {   // School of Public Health - Dallas
                        logoName = 'School of Public Health - Dallas';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-dallas.png" alt="School of Public Health - Dallas" /></td>;
                    } else if (parseInt(person.logo) === 13) {   // School of Public Health - El Paso
                        logoName = 'School of Public Health - El Paso';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-el-paso.png" alt="School of Public Health - El Paso" /></td>;
                    } else if (parseInt(person.logo) === 14) {   // School of Public Health - San Antonio
                        logoName = 'School of Public Health - San Antonio';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-san-antonio.png" alt="School of Public Health - San Antonio" /></td>;
                    } else if (parseInt(person.logo) === 15) {   // UTHealth Houston Children's Heart Institute
                        logoName = 'UTHealth Houston Children\'s Heart Institute';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/uth-childrens-heart.png" alt="UTHealth Houston Children's Heart Institute" /></td>;
                    } else if (parseInt(person.logo) === 16) {   // McWilliams School of Biomedical Informatics
                        logoName = 'McWilliams School of Biomedical Informatics';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/mcwilliams-logo-v82923.png" alt="McWilliams School of Biomedical Informatics" /></td>;
                    } else if (parseInt(person.logo) === 17) {   // UTHealth Houston Neurosciences
                        logoName = 'UTHealth Houston Neurosciences';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/UTHH-Neuroscience.png" alt="UTHealth Houston Neurosciences" /></td>;
                    } else if (parseInt(person.logo) === 18) {   // UTHealth Houston Cizik Eye Clinic
                        logoName = 'UTHealth Houston Cizik Eye Clinic';
                        logoImgColumn = <td className="logo-img"><img src="https://ac-ut-health.s3.amazonaws.com/css/UTHH-RobertCizikEyeClinic.png" alt="UTHealth Houston Cizik Eye Clinic" /></td>;
                    }

                    logoColumn = <td>{logoName}</td>;
                }

                let sizeName = '';
                if (item.size === 'XS') {
                    sizeName = 'Extra Small';
                } else if (item.size === 'SM') {
                    sizeName = 'Small';
                } else if (item.size === 'MD') {
                    sizeName = 'Medium';
                } else if (item.size === 'LG') {
                    sizeName = 'Large';
                } else if (item.size === 'XL') {
                    sizeName = 'Extra Large';
                } else if (item.size === '2XL') {
                    sizeName = '2XL';
                } else if (item.size === '3XL') {
                    sizeName = '3XL';
                } else if (item.size === '4XL') {
                    sizeName = '4XL';
                } else if (item.size === '5XL') {
                    sizeName = '5XL';
                } else if (item.size === '6XL') {
                    sizeName = '6XL';
                } else if (item.size === '7XL') {
                    sizeName = '7XL';
                } else if (item.size === '8XL') {
                    sizeName = '8XL';
                }

                let embroideryColumn = null;
                if (person.embroideryFirstLine !== undefined) {
                    embroideryColumn = (
                        <td>
                            <div><b>1st Line:</b> {person.embroideryFirstLine}</div>
                            <div><b>2nd Line:</b> {person.embroiderySecondLine}</div>
                            <div><b>Email:</b> {person.embroideryEmail}</div>
                        </td>
                    );
                }

                let personName = person.name;
                if (person.lastName !== undefined) {
                    let personNameParts = [person.name];
                    if (person.middleName !== '') {
                        personNameParts.push(person.middleName);
                    }
                    if (person.lastName !== '') {
                        personNameParts.push(person.lastName);
                    }
                    personName = personNameParts.join(' ');
                }

                return (
                    <tr key={index1 + '-' + index2}>
                        <td>{personName}</td>
                        {embroideryColumn}
                        {logoColumn}
                        {logoImgColumn}
                        <td>{sizeName}</td>
                        <td className="text-center">{numeral(item.unit_price).format('$0,0.00')}</td>
                        <td className="text-center">{numeral(item.quantity).format('0,0')}</td>
                        <td className="text-center">{numeral(item.total_price).format('$0,0.00')}</td>
                    </tr>
                );
            });
        });
    };

    const handleCheckoutItem = (id, event) => {
        props.checkoutItem(id, event.target.checked ? 1 : 0);
    };

    const renderItems = () => {
        if (props.fetching) {
            return <div><i className="fas fa-circle-notch fa-spin" /> Loading data...</div>;
        }

        if (props.items.length === 0) {
            return <div className="empty-cart">Your shopping cart is empty</div>;
        }

        return props.items.map((item, index) => {
            let color = null;
            let unitPrice = <div className="unit-price">(Unit Price: {numeral(item.unit_price).format('$0,0.00[0]')})</div>;
            if (item['variables'] && item['variables'] !== '') {
                let json = JSON.parse(item['variables']);
                if (json.staticTemplateCode) {
                    unitPrice = <div className="unit-price">(Price/Bundle: {numeral(item.unit_price).format('$0,0.00[0]')})</div>;
                }

                if (parseInt(json['staticTemplateCode']) === 647) {
                    unitPrice = <div className="unit-price">(Unit Price: {numeral(item.unit_price).format('$0,0.00[0]')})</div>;
                }

                if (json.color && json.color !== '') {
                    color = json.color;
                }
            }

            let loadingIcon = null;
            if (props.changingQuantity && parseInt(props.changingQuantityId) === parseInt(item.id)) {
                loadingIcon = <i className="fas fa-circle-notch fa-spin" />;
            }

            let language = null;
            let clinicContainer = null;
            let previewContainer = (
                <div className="pdf">
                    <Document file={item.pdf_url}>
                        <Page width="130" pageNumber={1} renderAnnotationLayer={false} />
                    </Document>
                </div>
            );
            let quantityContainer = (
                <div className="quantity">
                    <select value={item.quantity} onChange={handleChangeQuantity.bind(this, item.id)}>
                        {item.quantity_options.map((option) => {
                            return <option key={option.value} value={option.value}>{option.label}</option>;
                        })}
                    </select>
                    {loadingIcon}
                </div>
            );
            let descriptionContainer = (
                <div className="product-description">
                    <b>Description:</b>
                    <ul>
                        {item.product_descriptions.map((description, index) => {
                            return <li key={index}>{description}</li>;
                        })}
                    </ul>
                </div>
            );

            if (['p17t1', 'p17t4', 'p17t5'].includes(item.template_code)) {
                previewContainer = (
                    <div className="pdf">
                        <img src={item.pdf_url} alt="Pocket Folders" />
                    </div>
                );
            } else if (['p17t2'].includes(item.template_code)) {
                previewContainer = (
                    <div className="pdf">
                        <img src={item.preview_url} alt="Pocket Folders" />
                    </div>
                );
            } else if (['p17t3'].includes(item.template_code)) {
                previewContainer = (
                    <div className="pdf">
                        <img src={item.preview_url} alt="Pocket Folders" />
                    </div>
                );
            } else if (['p22t1', 'p22t2'].includes(item.template_code)) {
                const variables = JSON.parse(item.variables);

                let freeItems = null;
                if (item.available_items && item.available_items > 0) {
                    freeItems = <div className="free-items">You have <strong>{item.available_items}</strong> free item(s) available</div>;
                }

                language = <div><b>Language:</b> {variables['language']}</div>;
                previewContainer = (
                    <div className="pdf">
                        <img src={item.preview_url} alt="Card" />
                    </div>
                );
                quantityContainer = (
                    <div className="quantity">
                        Total: {item.quantity}
                        {freeItems}
                    </div>
                );
                descriptionContainer = (
                    <Fragment>
                        <div className="product-description mt-2">
                            <b>Description:</b>
                            <div>
                                This vinyl cling poster notifies patients to let their health care team know if they have recently
                                traveled internationally. The poster should be displayed in exam rooms or in lobbies.
                            </div>
                        </div>
                    </Fragment>
                );
                clinicContainer = (
                    <div className="">
                        <strong>Clinic:</strong> {variables.clinicName}
                    </div>
                );
            } else if (['p22t3'].includes(item.template_code)) {
                const variables = JSON.parse(item.variables);

                let freeItems = null;
                if (item.available_items && item.available_items > 0) {
                    freeItems = <div className="free-items">You have <strong>{item.available_items}</strong> free item(s) available</div>;
                }

                previewContainer = (
                    <div className="pdf">
                        <img src={item.preview_url} alt="Card" />
                    </div>
                );
                quantityContainer = (
                    <div className="quantity">
                        Total: {item.quantity}
                        {freeItems}
                    </div>
                );
                descriptionContainer = (
                    <Fragment>
                        <div className="product-description mt-2">
                            <b>Description:</b>
                            <div>
                                This bilingual (English and Spanish) vinyl cling notifies patients that photography, videography, or audio 
                                recording is not permitted without consent. The poster can be displayed in exam rooms, specifically on the 
                                back of exam room doors or on cabinet doors.
                            </div>
                        </div>
                    </Fragment>
                );
                clinicContainer = (
                    <div className="">
                        <strong>Clinic:</strong> {variables.clinicName}
                    </div>
                );
            }

            if (['p4t3'].includes(item.template_code)) {
                const variables = JSON.parse(item.variables);

                let url = null;
                if (parseInt(variables.color) === 1) {
                    url = 'https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p4t3-color.png';
                } else if (parseInt(variables.color) === 2) {
                    url = 'https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p4t3-orange.png';
                } else if (parseInt(variables.color) === 3) {
                    url = 'https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p4t3-black.png';
                }

                previewContainer = (
                    <div className="pdf">
                        <img src={url} alt="Notecard" />
                    </div>
                );
            }

            if (['p18t1', 'p18t4'].includes(item.template_code)) {
                previewContainer = (
                    <div className="pdf">
                        <img src={item.preview_url} alt="Notepads" />
                    </div>
                );
            }

            if (['p19t1'].includes(item.template_code)) {
                let variables = JSON.parse(item['variables']);

                let card1Image = null;
                if (parseInt(variables.quantity1) > 0) {
                    card1Image = <img className="holiday-image mt-2" src="https://ac-ut-health.s3.us-east-1.amazonaws.com/static-images/printready-holiday-card-1-211124.jpg" alt="Holiday" />;
                }

                let card2Image = null;
                if (parseInt(variables.quantity2) > 0) {
                    card2Image = <img className="holiday-image mt-2" src="https://ac-ut-health.s3.us-east-1.amazonaws.com/static-images/printready-holiday-card-2-211124.jpg" alt="Holiday" />;
                }

                let card3Image = null;
                if (parseInt(variables.quantity3) > 0) {
                    card3Image = <img className="holiday-image mt-2" src="https://ac-ut-health.s3.us-east-1.amazonaws.com/static-images/printready-holiday-card-3-211124.jpg" alt="Holiday" />;
                }

                previewContainer = (
                    <div className="pdf">
                        {card1Image}
                        {card2Image}
                        {card3Image}
                    </div>
                );
            }

            let schedulingCardLocationRow = null;
            if (['p1t12'].includes(item.template_code)) {
                previewContainer = (
                    <div className="pdf">
                        <img src={item.pdf_url} alt="Checks" />
                    </div>
                );
            } else if (['p1t17'].includes(item.template_code)) {
                previewContainer = (
                    <div className="pdf">
                        <img src={item.pdf_url} alt="Card" />
                    </div>
                );
            } else if (['p1t18'].includes(item.template_code)) {
                let variables = JSON.parse(item['variables']);

                let schedulingCardLocation = null;
                if (parseInt(variables.schedulingCard) === 1) {
                    schedulingCardLocation = 'The Woodlands'
                } else if (parseInt(variables.schedulingCard) === 2) {
                    schedulingCardLocation = 'Texas Medical Center'
                } else if (parseInt(variables.schedulingCard) === 3) {
                    schedulingCardLocation = 'Facial Plastic Surgery'
                } else if (parseInt(variables.schedulingCard) === 4) {
                    schedulingCardLocation = 'Pediatric ENT'
                } else if (parseInt(variables.schedulingCard) === 5) {
                    schedulingCardLocation = 'Greater Heights'
                } else if (parseInt(variables.schedulingCard) === 6) {
                    schedulingCardLocation = 'Southeast Houston'
                }

                schedulingCardLocationRow = <div><b>Location:</b> {schedulingCardLocation}</div>;
                previewContainer = (
                    <div className="pdf">
                        <img src={item.pdf_url} alt="Card" />
                    </div>
                );
            }

            if (item.product_type === 'Apparel') {
                unitPrice = null;

                let imageUrl = require('./../images/no-image.jpg');
                if (item.pdf_url && item.pdf_url != null && item.pdf_url !== '' && item.pdf_url !== '-') {
                    imageUrl = item.pdf_url;
                }

                previewContainer = (
                    <div className="pdf">
                        <img src={imageUrl} alt="Apparel" />
                    </div>
                );
            } else if (item.product_type === 'Stationery Letterheads' && item.template_code === 'p2t2') {
                let img = null;
                if (parseInt(color) === 1) {
                    img = <img className="preview-image p2t2-img" src={require('./../../Editor/images/utp-letterhead-color-restricted.png')} alt="Letterhead" />
                } else if (parseInt(color) === 2) {
                    img = <img className="preview-image p2t2-img" src={require('./../../Editor/images/utp-letterhead-bw-restricted.png')} alt="Letterhead" />
                }

                previewContainer = <div className="pdf">{img}</div>;
            } else if (item.product_type === 'Stationery Letterheads' && item.template_code === 'p2t4') {
                let img = <img className="preview-image p2t4-img" src="https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p2t4.png" alt="Letterhead" />
                previewContainer = <div className="pdf">{img}</div>;
            } else if (item.product_type === 'Promotional') {
                const variables = JSON.parse(item['variables']);

                let logoImage = null;
                if (parseInt(variables.logo) === 1) {    // UTP
                    logoImage = <img src="https://ac-ut-health.s3.us-east-1.amazonaws.com/css/utp-logo-030325.png" alt="UTP" className="utp-logo" />;
                } else if (parseInt(variables.logo) === 2) {    // UTH
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/uth-new-logo-low.png" alt="UTH" className="uth-utp-logo" />;
                } else if (parseInt(variables.logo) === 3) {     // UTH Houston
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-houston-logo.png" alt="UTH Houston" className="uth-houston-logo" />
                } else if (parseInt(variables.logo) === 4) {     // Cizik School of Nursing
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-cizik.logo.png" alt="Cizik School of Nursing" className="uth-cizik-logo" />
                } else if (parseInt(variables.logo) === 5) {     // McGovern Medical School
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-mcgovern-logo.png" alt="McGovern Medical School" className="uth-mcgovern-logo" />
                } else if (parseInt(variables.logo) === 6) {     // School of Biomedical Informatics
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-biomedical-informatics-logo.png" alt="School of Biomedical Informatics" className="uth-biomedical-informatics-logo" />
                } else if (parseInt(variables.logo) === 7) {     // School of Dentistry
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-dentistry-logo.png" alt="School of Dentistry" className="uth-dentistry-logo" />
                } else if (parseInt(variables.logo) === 8) {     // School of Public Health
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-public-health-logo.png" alt="School of Public Health" className="uth-public-health-logo" />
                } else if (parseInt(variables.logo) === 9) {     // UTHealth Houston General
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-general-logo.png" alt="UTHealth Houston General" className="uth-general-logo" />
                } else if (parseInt(variables.logo) === 10) {     // School of Public Health - Austin
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-austin.png" alt="School of Public Health - Austin" className="uth-public-health-austin-logo" />
                } else if (parseInt(variables.logo) === 11) {     // School of Public Health - Brownsville
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-brownsville.png" alt="School of Public Health - Brownsville" className="uth-public-health-brownsville-logo" />
                } else if (parseInt(variables.logo) === 12) {     // School of Public Health - Dallas
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-dallas.png" alt="School of Public Health - Dallas" className="uth-public-health-dallas-logo" />
                } else if (parseInt(variables.logo) === 13) {     // School of Public Health - El Paso
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-el-paso.png" alt="School of Public Health - El Paso" className="uth-public-health-el-paso-logo" />
                } else if (parseInt(variables.logo) === 14) {     // School of Public Health - San Antonio
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-san-antonio.png" alt="School of Public Health - San Antonio" className="uth-public-health-san-antonio-logo" />
                } else if (parseInt(variables.logo) === 15) {     // UTHealth Houston Children's Heart Institute
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-childrens-heart.png" alt="UTHealth Houston Children's Heart Institute" className="uth-childrens-heart" />
                } else if (parseInt(variables.logo) === 16) {     // McWilliams School of Biomedical Informatics
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/mcwilliams-logo-v82923.png" alt="McWilliams School of Biomedical Informatics" className="uth-childrens-heart" />
                }

                if (parseInt(variables.promotionalTemplateCode) === 16) {
                    logoImage = null;
                }

                previewContainer = (
                    <div className="pdf">
                        <img src={item.pdf_url} alt="Promotional" />
                        <div className="logo-image">
                            {logoImage}
                        </div>
                    </div>
                );
            } else if (item.template_code === 'p3t3') {
                previewContainer = (
                    <div className="pdf">
                        <Document file={item.preview_url}>
                            <Page width="130" pageNumber={1} renderAnnotationLayer={false} />
                        </Document>
                    </div>
                );
            } else if (item.product_type === 'MyUTHealth') {
                previewContainer = (
                    <div className="pdf">
                        <img src={item.preview_url} alt="Promotional" />
                    </div>
                );
            } else if (item.product_type === 'Brochures & Flyers') {
                if ([11, 13, 14].includes(parseInt(item.template_code))) {
                    previewContainer = (
                        <div className="pdf">
                            <img src={item.preview_url} alt="Brochures and Flyers" />
                        </div>
                    );
                } else if (parseInt(item.template_code) === 12) {
                    const variables = JSON.parse(item['variables']);

                    if (parseInt(variables['type']) === 1) {
                        previewContainer = (
                            <div className="pdf">
                                <img src={item.pdf_url} alt="Brochures and Flyers" />
                            </div>
                        );
                    } else {
                        previewContainer = (
                            <div className="pdf">
                                <Document file={item.pdf_url}>
                                    <Page width="130" pageNumber={1} renderAnnotationLayer={false} />
                                </Document>
                            </div>
                        );
                    }
                } else {
                    previewContainer = (
                        <div className="pdf">
                            <img src={item.pdf_url} alt="Brochures and Flyers" />
                        </div>
                    );
                }
            } else if (item.product_type === 'NRC') {
                previewContainer = (
                    <div className="pdf">
                        <img src={item.preview_url} alt="NRC" />
                    </div>
                );
            } else if (item.product_type === 'Forms') {
                let variables = JSON.parse(item['variables']);
                if (parseInt(variables['staticTemplateCode']) === 473) {
                    previewContainer = (
                        <div className="pdf">
                            <img src={item.pdf_url} alt="Forms" />
                        </div>
                    );
                } else if (parseInt(variables['staticTemplateCode']) === 647) {
                    previewContainer = (
                        <div className="pdf">
                            <Document file={item.pdf_url}>
                                <Page width="130" pageNumber={1} renderAnnotationLayer={false} />
                            </Document>
                        </div>
                    );
                }
            }

            let penClinicName = null;
            let penPhone = null;
            let penInk = null;
            let penDescription = null;
            if (item.product_type === 'Promotional' && parseInt(item.template_code) === 20) {
                const variables = JSON.parse(item['variables']);

                if (variables.clinicName && variables.clinicName !== '') {
                    penClinicName = <div><b>Line 2 (Clinic Name):</b> {variables.clinicName}</div>;
                }
                if (variables.phone && variables.phone !== '') {
                    penPhone = <div><b>Line 3 (Phone):</b> {variables.phone}</div>;
                }
                penInk = <div><b>Ink:</b> {variables.ink}</div>;
                penDescription = (
                    <div>
                        <h6 className="text-left">Silk Screen Imprint: 1 1/2" W x 3/4"</h6>
                        <p>Recommended Imprint Color: White or Black</p>
                        <p>Standard Production on catalog quantities is 5 days after proof approval, and AR approval. Added imprint options or special packaging may require additional production time.</p>
                        <p>
                            <div><b>Material:</b> Plastic</div>
                            <div><b>Mechanism:</b> Push Retractable</div>
                            <div><b>Tip Type:</b> Ballpoint</div>
                            <div><b>Product Size:</b> 5 5/7" L x 1/3" Dia.</div>
                            <div><b>Shipping Information:</b> 5 lbs per 250</div>
                        </p>
                    </div>
                );
            }

            let editItem = <button className="edit-button" onClick={handleEditProduct.bind(this, item.id)}>Edit Item</button>;

            if (['p9t1', 'p9t2', 'p9t3', 'p9t4', 'p9t5', 'p9t6', 'p9t7', 'p9t8', 'p9t9', 'p9t10', 'p9t11', 'p9t12', 'p9t13', 'p9t14', 
                'p9t15', 'p9t16', 'p9t17', 'p9t18', 'p9t19', 'p9t20', 'p9t21', 'p9t22', 'p9t23'].includes(item.template_code)) {
                let pdfUrl = item.pdf_url;
                if (item.preview_url && item.preview_url !== '') {
                    pdfUrl = item.preview_url;
                }

                previewContainer = (
                    <div className="pdf">
                        <Document file={pdfUrl}>
                            <Page width="130" pageNumber={1} renderAnnotationLayer={false} />
                        </Document>
                    </div>
                );
            } else if (['p10t1', 'p10t2', 'p10t3', 'p10t4', 'p10t5', 'p10t6', 'p10t7', 'p10t8', 'p10t9', 'p10t10'].includes(item.template_code)) {
                let pdfUrl = item.pdf_url;
                if (item.preview_url && item.preview_url !== '') {
                    pdfUrl = item.preview_url;
                }

                previewContainer = (
                    <div className="pdf">
                        <Document file={pdfUrl}>
                            <Page width="130" pageNumber={1} renderAnnotationLayer={false} />
                        </Document>
                    </div>
                );
            } else if (['p11t1', 'p11t2', 'p11t3', 'p11t4', 'p11t5', 'p11t6', 'p11t7', 'p11t22', 'p11t23', 'p11t24', 'p11t25'].includes(item.template_code)) {
                let pdfUrl = item.pdf_url;
                if (item.preview_url && item.preview_url !== '') {
                    pdfUrl = item.preview_url;
                }

                previewContainer = (
                    <div className="pdf">
                        <Document file={pdfUrl}>
                            <Page width="130" pageNumber={1} renderAnnotationLayer={false} />
                        </Document>
                    </div>
                );

                const variables = JSON.parse(item['variables']);

                let windowDescription = null;
                if (variables.window) {
                    windowDescription = <li key="window-desc"><span className="window-desc">Window Envelope: {parseInt(variables.window) ? 'Yes' : 'No'}</span></li>;
                }

                descriptionContainer = (
                    <div className="product-description">
                        <b>Description:</b>
                        <ul>
                            {item.product_descriptions.map((description, index) => {
                                return <li key={index}>{description}</li>;
                            })}
                            {windowDescription}
                        </ul>
                        {penDescription}
                    </div>
                );
            } else if (['p12t1', 'p12t2', 'p12t3', 'p12t4', 'p12t5', 'p12t6', 'p12t7', 'p12t8', 'p12t9', 'p12t10'].includes(item.template_code)) {
                const variables = JSON.parse(item['variables']);

                previewContainer = (
                    <div className="pdf">
                        <img src={item.preview_url} alt="A6 Card" />
                    </div>
                );

                let envelopesDescription = null;
                if (parseInt(variables.addEnvelopes)) {
                    envelopesDescription = (
                        <div className="product-description mt-2">
                            <b>A6 Envelope:</b>
                            <ul>
                                <li>Flat: 6.5" x 4.75"</li>
                                <li>Stock: A6 Opaque White</li>
                                <li>Printed: Color one side</li>
                            </ul>
                        </div>
                    );
                }

                descriptionContainer = (
                    <Fragment>
                        <div className="product-description mt-2">
                            <b>Thank You Card:</b>
                            <ul>
                                <li>Flat: 6" x 9"</li>
                                <li>Folded: 6" x 4.5" (Finish Size)</li>
                                <li>Stock: 100# Opaque White Cover</li>
                                <li>Printed: Color one side</li>
                            </ul>
                        </div>
                        {envelopesDescription}
                    </Fragment>
                );
            } else if (['p18t2'].includes(item.template_code)) {
                descriptionContainer = (
                    <div className="product-description">
                        <b>Description:</b>
                        <div className="mb-1">
                            Security prescription pads must only be ordered as part of our emergency procedures for Epic downtime.
                            All emergency prescription pads should be stored in a locked cabinet accessed by clinic leadership only.
                        </div>
                        <ul>
                            {item.product_descriptions.map((description, index) => {
                                return <li key={index}>{description}</li>;
                            })}
                        </ul>
                        {penDescription}
                    </div>
                );
            } else if (['p20t1', 'p20t2', 'p20t3', 'p20t4', 'p20t5', 'p20t6', 'p20t7', 'p20t8', 'p20t9'].includes(item.template_code)) {
                let pdfUrl = item.pdf_url;
                if (item.preview_url && item.preview_url !== '') {
                    pdfUrl = item.preview_url;
                }

                previewContainer = (
                    <div className="pdf">
                        <Document file={pdfUrl}>
                            <Page width="130" pageNumber={1} renderAnnotationLayer={false} />
                        </Document>
                    </div>
                );
            }

            let apparelTable = null;
            if (item.product_type === 'Apparel') {
                quantityContainer = (
                    <div className="quantity">
                        Total: {item.quantity}
                    </div>
                );

                const variables = JSON.parse(item['variables']);

                if (parseInt(item.template_code) === 125) {
                    editItem = null;

                    const imagePositions = [];
                    if (parseInt(variables.uth_unisex_position_full_front) === 1) {
                        imagePositions.push(<li>Full Front (image size: 12" w x 16" h)</li>);
                    }
                    if (parseInt(variables.uth_unisex_position_full_back) === 1) {
                        imagePositions.push(<li>Full Back (image size: 12" w x 16" h)</li>);
                    }
                    if (parseInt(variables.uth_unisex_position_left_chest) === 1) {
                        imagePositions.push(<li>Left Chest (image size: 4" w x 2" h)</li>);
                    }
                    if (parseInt(variables.uth_unisex_position_right_chest) === 1) {
                        imagePositions.push(<li>Right Chest (image size: 4" w x 2" h)</li>);
                    }
                    if (parseInt(variables.uth_unisex_position_sleeve) === 1) {
                        imagePositions.push(<li>Sleeve (image size: 2" w x 1" h)</li>);
                    }
                    if (parseInt(variables.uth_unisex_position_other) === 1) {
                        imagePositions.push(<li>Other area ({variables.uth_unisex_position_other_text})</li>);
                    }

                    const inks = [];
                    if (parseInt(variables.uth_unisex_ink_university_orange) === 1) {
                        inks.push(<li>University Orange (PMS 167U)</li>);
                    }
                    if (parseInt(variables.uth_unisex_ink_university_blue) === 1) {
                        inks.push(<li>University Blue (PMS 5405U)</li>);
                    }
                    if (parseInt(variables.uth_unisex_ink_university_grey) === 1) {
                        inks.push(<li>University Gray (Cool Gray 11U)</li>);
                    }
                    if (parseInt(variables.uth_unisex_ink_university_black_white) === 1) {
                        inks.push(<li>University Black &amp; White</li>);
                    }
                    if (parseInt(variables.uth_unisex_ink_gulf_blue) === 1) {
                        inks.push(<li>Gulf Blue (PMS 295U)</li>);
                    }
                    if (parseInt(variables.uth_unisex_ink_mustard) === 1) {
                        inks.push(<li>Mustard (PMS 7406U)</li>);
                    }
                    if (parseInt(variables.uth_unisex_ink_dark_sage) === 1) {
                        inks.push(<li>Dark Sage (PMS 555U)</li>);
                    }
                    if (parseInt(variables.uth_unisex_ink_dusty_lavender) === 1) {
                        inks.push(<li>Dusty Lavender (PMS 668U)</li>);
                    }

                    let shirtColor = [];
                    if (parseInt(variables.uth_unisex_shirt_color) === 1) {
                        shirtColor.push(<li>White 100% cotton</li>);
                    } else if (parseInt(variables.uth_unisex_shirt_color) === 2) {
                        shirtColor.push(<li>Black 100% cotton</li>);
                    } else if (parseInt(variables.uth_unisex_shirt_color) === 3) {
                        shirtColor.push(<li>Navy 100% cotton</li>);
                    } else if (parseInt(variables.uth_unisex_shirt_color) === 4) {
                        shirtColor.push(<li>Texas Orange 100% cotton</li>);
                    }

                    const sizes = [];
                    if (parseInt(variables.uth_unisex_size_small) === 1) {
                        sizes.push(<li>Small (Qty: {variables.uth_unisex_size_small_qty})</li>);
                    }
                    if (parseInt(variables.uth_unisex_size_medium) === 1) {
                        sizes.push(<li>Medium (Qty: {variables.uth_unisex_size_medium_qty})</li>);
                    }
                    if (parseInt(variables.uth_unisex_size_large) === 1) {
                        sizes.push(<li>Large (Qty: {variables.uth_unisex_size_large_qty})</li>);
                    }
                    if (parseInt(variables.uth_unisex_size_xl) === 1) {
                        sizes.push(<li>X-Large (Qty: {variables.uth_unisex_size_xl_qty})</li>);
                    }
                    if (parseInt(variables.uth_unisex_size_2xl) === 1) {
                        sizes.push(<li>2XL (Qty: {variables.uth_unisex_size_2xl_qty})</li>);
                    }
                    if (parseInt(variables.uth_unisex_size_3xl) === 1) {
                        sizes.push(<li>3XL (Qty: {variables.uth_unisex_size_3xl_qty})</li>);
                    }

                    let filesContainer = null;
                    if (variables.uth_unisex_files.length > 0) {
                        const files = [];
                        for (let i = 0; i < variables.uth_unisex_files.length; i++) {
                            const file = variables.uth_unisex_files[i];
                            files.push(<li><a href={file.url} target="_blank" rel="noopener noreferrer">{file.name}</a></li>);
                        }
                        filesContainer = (
                            <Fragment>
                                <div><b>Files:</b></div>
                                <ul className="sizes-list">
                                    {files}
                                </ul>
                            </Fragment>
                        );
                    }

                    apparelTable = (
                        <div className="apparel-table mb-2">
                            <b>Details:</b>
                            <div><b>Image Position:</b></div>
                            <ul className="image-positions-list">
                                {imagePositions}
                            </ul>
                            <div><b>Ink:</b></div>
                            <ul className="inks-list">
                                {inks}
                            </ul>
                            <div><b>Shirt Color:</b></div>
                            <ul className="inks-list">
                                {shirtColor}
                            </ul>
                            <div><b>Sizes:</b></div>
                            <ul className="sizes-list">
                                {sizes}
                            </ul>
                            {filesContainer}
                        </div>
                    );
                } else {
                    let persons = null;
                    let hasLogo = false;
                    let hasEmbroidery = false;
                    if (item['variables'] && item['variables'] !== '') {
                        let variablesJson = JSON.parse(item['variables']);
                        persons = variablesJson.personsParsed;

                        if (persons[0].logo !== undefined) {
                            hasLogo = true;
                        }

                        if (persons[0].embroideryFirstLine !== undefined) {
                            hasEmbroidery = true;
                        }
                    }

                    apparelTable = (
                        <div className="apparel-table">
                            <b>Details:</b>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        {hasEmbroidery ? <th>Embroidery</th> : null}
                                        {hasLogo ? <th>Logo</th> : null}
                                        {hasLogo ? <th>Logo Image</th> : null}
                                        <th>Size</th>
                                        <th className="text-center">Unit Price</th>
                                        <th className="text-center">Qty</th>
                                        <th className="text-center">Total Price</th>
                                    </tr>
                                </thead>
                                <tbody>{renderApparelDetails(persons, item)}</tbody>
                            </table>
                        </div>
                    );
                }
            }
            if (item.product_type === 'Holiday') {
                let variables = JSON.parse(item['variables']);

                let card1Total = null;
                if (parseInt(variables.quantity1) > 0) {
                    card1Total = <Fragment><b>Card 1 Quantity:</b> {variables.quantity1}</Fragment>;
                }

                let card2Total = null;
                if (parseInt(variables.quantity2) > 0) {
                    card2Total = <Fragment><b>Card 2 Quantity:</b> {variables.quantity2}</Fragment>;
                }

                let card3Total = null;
                if (parseInt(variables.quantity3) > 0) {
                    card3Total = <Fragment><b>Card 3 Quantity:</b> {variables.quantity3}</Fragment>;
                }

                quantityContainer = (
                    <div className="quantity">
                        <div>{card1Total}</div>
                        <div>{card2Total}</div>
                        <div>{card3Total}</div>
                    </div>
                );
            }

            let shippingPrice = (
                <div className="shipping-rate">
                    <div className="label">Shipping TBD</div>
                    <div className="disclaimer">
                        * Bulk shipping rates may be applicable if multiple orders are placed for the same address.
                    </div>
                </div>
            );
            // if (parseFloat(item.shipping_price) > 0) {}

            let paper = null;
            let clinicName = null;
            let location = null;
            if (item.product_type === 'MyUTHealth') {
                const variables = JSON.parse(item['variables']);
                if (parseInt(item.template_code) !== 9) {
                    language = <div><b>Language:</b> {variables['language']}</div>;
                }

                if (variables['clinic'] !== '') {
                    clinicName = <div><b>Clinic Name:</b> {variables['clinic']}</div>;
                } else {
                    clinicName = <div><b>Clinic Name:</b> {variables['clinicName']}</div>;
                }

                if (variables['location'] !== '') {
                    location = <div><b>Location:</b> {variables['location']}</div>;
                } else {
                    location = <div><b>Location:</b> {variables['yourLocation']}</div>;
                }

                if (parseInt(item.template_code) === 10) {
                    language = null;
                    clinicName = null;
                    location = null;
                }
            }

            let image = null;
            if (item.product_type === 'NRC') {
                const variables = JSON.parse(item['variables']);
                image = <div><b>Image:</b> {variables['image']}</div>;
            }

            let covidPosterDescription = null;
            let orientation = null;
            let materialType = null;
            let size = null;
            if (item.product_type === 'Forms' && parseInt(item.template_code) === 473) {
                const variables = JSON.parse(item['variables']);
                descriptionContainer = null;
                language = <div><b>Language:</b> {variables['language']}</div>;
                orientation = <div><b>Orientation:</b> {variables['orientation']}</div>;
                materialType = <div><b>Material Type:</b> {variables['materialType']}</div>;
                size = <div><b>Size:</b> {variables['size']}</div>;
            } else if (item.product_type === 'Forms' && parseInt(item.template_code) === 647) {
                const variables = JSON.parse(item['variables']);
                descriptionContainer = null;
                language = <div><b>Language:</b> {variables['language']}</div>;
                materialType = <div><b>Type:</b> {variables['type']}</div>;
            } else if (item.product_type === 'Forms' && parseInt(item.template_code) === 648) {
                const variables = JSON.parse(item['variables']);
                language = <div><b>Language:</b> {variables['language']}</div>;
            } else if (item.product_type === 'Forms' && parseInt(item.template_code) === 649) {
                const variables = JSON.parse(item['variables']);
                language = <div><b>Language:</b> {variables['language']}</div>;
            }

            let printingOption = null;
            if (item.product_type === 'Forms') {
                const variables = JSON.parse(item['variables']);
                if (variables['printingOption'] && variables['printingOption'] === 'color') {
                    printingOption = <div><b>Printing Option:</b> Color</div>;
                } else if (variables['printingOption'] && variables['printingOption'] === 'bw') {
                    printingOption = <div><b>Printing Option:</b> Black &amp; White</div>;
                }
            }

            let checkingOut = null;
            if (props.checkingOut && parseInt(props.checkingId) === parseInt(item.id)) {
                checkingOut = <i className="fas fa-circle-notch fa-spin" />;
            }

            let apparelNotice = null;
            if (item.product_type === 'Apparel') {
                apparelNotice = (
                    <div className="notice">
                        All apparel orders are non-returnable. If you would like to schedule a fitting, please send us a message through the Help Desk link so we can contact you.
                    </div>
                );
            }

            let promotionalLogo = null;
            if (item.product_type === 'Promotional') {
                const variables = JSON.parse(item['variables']);

                let logoName = '';
                if (parseInt(variables.logo) === 1) {
                    logoName = 'UT Physicians';
                } else if (parseInt(variables.logo) === 2) {
                    logoName = 'UTHealth Houston';
                } else if (parseInt(variables.logo) === 3) {
                    logoName = 'Heart and Vascular';
                } else if (parseInt(variables.logo) === 4) {
                    logoName = 'Cizik School of Nursing';
                } else if (parseInt(variables.logo) === 5) {
                    logoName = 'McGovern Medical School';
                } else if (parseInt(variables.logo) === 6) {
                    logoName = 'School of Biomedical Informatics';
                } else if (parseInt(variables.logo) === 7) {
                    logoName = 'School of Dentistry';
                } else if (parseInt(variables.logo) === 8) {
                    logoName = 'School of Public Health';
                } else if (parseInt(variables.logo) === 9) {
                    // logoName = 'UTHealth Houston General';
                } else if (parseInt(variables.logo) === 10) {
                    logoName = 'School of Public Health - Austin';
                } else if (parseInt(variables.logo) === 11) {
                    logoName = 'School of Public Health - Brownsville';
                } else if (parseInt(variables.logo) === 12) {
                    logoName = 'School of Public Health - Dallas';
                } else if (parseInt(variables.logo) === 13) {
                    logoName = 'School of Public Health - El Paso';
                } else if (parseInt(variables.logo) === 14) {
                    logoName = 'School of Public Health - San Antonio';
                } else if (parseInt(variables.logo) === 16) {
                    logoName = 'McWilliams School of Biomedical Informatics';
                } else if (parseInt(variables.logo) === 15) {
                    logoName = 'UTHealth Houston Children\'s Heart Institute';
                }

                promotionalLogo = (
                    <div><b>Logo:</b> {logoName}</div>
                );
            }

            if (item.product_type === 'Forms' && parseInt(item.template_code) === 650) {
                previewContainer = (
                    <div className="pdf">
                        <img src={item.preview_url} alt="Form" />
                    </div>
                );
            }
            if (item.product_type === 'Forms' && parseInt(item.template_code) === 651) {
                const variables = JSON.parse(item.variables);
                language = <div><b>Language:</b> {variables['language']}</div>;
                materialType = <div><b>Result:</b> {variables['type']}</div>;
                previewContainer = (
                    <div className="pdf">
                        <img src={item.preview_url} alt="Form" />
                    </div>
                );

                let sidedItem = <li>4/0 with bleed</li>;
                if (variables.type === 'Did Not Pass') {
                    sidedItem = <li>4/4 with bleed</li>;
                }

                descriptionContainer = (
                    <div className="product-description">
                        <b>Description:</b>
                        <ul>
                            <li>8.5x11"</li>
                            <li>28# text paper</li>
                            {sidedItem}
                            <li>Printed in bundles of 500</li>
                        </ul>
                    </div>
                );
            }
            if (item.product_type === 'Forms' && parseInt(item.template_code) === 652) {
                previewContainer = (
                    <div className="pdf">
                        <img src={item.preview_url} alt="Form" />
                    </div>
                );
            }

            return (
                <div key={item.id} className="item-card">
                    {previewContainer}
                    {quantityContainer}
                    <div className="product-name">
                        <div className="product-type"><b>Product Type:</b> {item.product_type}</div>
                        <div><b>Title:</b> {item.product_name}</div>
                        {promotionalLogo}
                        {schedulingCardLocationRow}
                        {penClinicName}
                        {penPhone}
                        {penInk}
                        {language}
                        {clinicContainer}
                        {paper}
                        {orientation}
                        {materialType}
                        {size}
                        {clinicName}
                        {location}
                        {image}
                        {covidPosterDescription}
                        {printingOption}
                        {descriptionContainer}
                        {apparelTable}
                        {apparelNotice}
                        {shippingPrice}
                    </div>
                    <div className="total-price">
                        <div className="delete-icon">
                            <Tooltip title="Remove Item" position="top" arrow size="small" className="action-tooltip">
                                <i className="fas fa-trash" onClick={props.deleteItem.bind(this, item.id)} />
                            </Tooltip>
                        </div>
                        <div>{numeral(item.total_price - item.shipping_price - item.tax_price).format('$0,0.00')}</div>
                        {unitPrice}
                        {editItem}
                        <div className="add-checkout">
                            <div className="saving-checkout">{checkingOut}</div>
                            <input type="checkbox" checked={item.checkout} onClick={handleCheckoutItem.bind(this, item.id)} /> Add to Checkout
                        </div>
                    </div>
                </div>
            );
        });
    };

    let buttonLabel = 'Checkout';
    if (props.checking) {
        buttonLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /></Fragment>;
    }

    let total = 0;
    let subtotal = 0;
    for (let i = 0; i < props.items.length; i++) {
        if (parseInt(props.items[i].checkout) === 0) {
            continue;
        }

        subtotal += props.items[i].total_price - props.items[i].shipping_price - props.items[i].tax_price;
        total += props.items[i].total_price;
    }
    let tax = subtotal * 0.0825;

    const handleCheckout = () => {
        if (props.items.length === 0) {
            return showNotification('Info', 'The shopping cart is empty', 'info');
        }

        let readyToCheckout = false;
        for (let i = 0; i < props.items.length; i++) {
            if (parseInt(props.items[i].checkout) === 1) {
                readyToCheckout = true;
                break;
            }
        }

        if (!readyToCheckout) {
            return showNotification('Select items', 'Select at least one item to checkout using the "Add to Checkout" field', 'info');
        }

        if (props.cxmlData.buyer_cookie == null) {
            props.history.push('/order');
        } else {
            props.checkout();
        }
    };

    const handleContinueShopping = () => {
        props.history.push('/');
    };

    let checkoutButton = <div><button type="button" disabled={props.checking || props.changingQuantity} onClick={handleCheckout}>{buttonLabel}</button></div>;
    if (props.user && (props.user.username === 'demo' || props.user.username === 'utdemo' || props.user.username === 'personal.demo')) {
        checkoutButton = null;
    }
    if (props.user.is_marketing && parseInt(props.user.is_marketing) === 1) {
        checkoutButton = null;
    }

    let totalsContainer = null;
    if (!isPersonal) {
        totalsContainer = (
            <div className="totals-container">
                <div className="totals">
                    <div className="prices">
                        <div className="grand-total">Total: <span>{numeral(total).format('$0,0.00')}</span></div>
                    </div>
                    <div className="checkout">
                        {checkoutButton}
                        <div className="continue-shopping">
                            <button type="button" onClick={handleContinueShopping}>Continue Shopping</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        const handleChangeShippingType = (event) => {
            props.setShippingType(event.target.value);
        };

        if (parseInt(props.shippingType) === 1) {
            total += 18;
        }

        totalsContainer = (
            <div className="totals-container">
                <div className="totals">
                    <div className="personal-prices">
                        <div className="subtotal">
                            <div className="label">Subtotal:</div>
                            <div className="price">{numeral(subtotal).format('$0,0.00')}</div>
                        </div>
                        <div className="tax">
                            <div className="label">Tax:</div>
                            <div className="price">{numeral(tax).format('$0,0.00')}</div>
                        </div>
                        <div className="shipping">
                            <div className="label">Shipping:</div>
                            <div className="div">
                                <select value={props.shippingType} onChange={handleChangeShippingType}>
                                    <option value="1">Flat Rate ($18.00)</option>
                                    <option value="2">Customer Pickup</option>
                                </select>
                            </div>
                        </div>
                        <div className="grand-total">
                            <div className="label">Total:</div>
                            <div className="price">{numeral(total).format('$0,0.00')}</div>
                        </div>
                    </div>
                    <div className="checkout">
                        {checkoutButton}
                        <div className="continue-shopping">
                            <button type="button" onClick={handleContinueShopping}>Continue Shopping</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="table-container">
            <div className="item-card-header">
                <div className="pdf">Preview</div>
                <div className="quantity">Quantity</div>
                <div className="product-name">Product</div>
                <div className="total-price">Total Price</div>
            </div>
            {renderItems()}
            {totalsContainer}
            <form id="cxml-form" action={props.cxmlData.browser_form_post} method="post" className="text-center">
                <input type="hidden" id="cxml-urlencoded" name="cxml-urlencoded" value="" />
            </form>
        </div>
    );
});

export default Table;
